import React from "react";
import parkingProductsActions from "../../store/actions/parkingProducts.actions";
import { StartBulkInvitationsRequestModel } from "../../models/bulkImport/StartBulkInvitationsRequestModel";
import MultipleDelegeesForm from "../MultipleDelegeesForm/MultipleDelegeesForm";
import { RootState, useAppDispatch, useAppSelector } from "../../store";
import { ValidateDelegeesRequestModel } from "../../models/bulkImport/ValidateDelegeesRequestModel";
import { ValidateDelegeesResponseModel } from "../../models/bulkImport/ValidateDelegeesResponseModel";
import parkingProductsService from "../../services/parkingProducts.service";
import { AxiosResponse } from "axios";

interface ParkingRightMultipleDelegeesFormProps {
  onClose: () => void;
  translationContextName: string;
}

const ParkingRightMultipleDelegeesForm: React.FC<ParkingRightMultipleDelegeesFormProps> = ({
  onClose,
  translationContextName
}) => {
  const dispatch = useAppDispatch();

  // Select state from Redux store
  const validateDelegeesProgress = useAppSelector((state: RootState) => state.parkingProducts.validateDelegees);
  const hasErrors = useAppSelector((state: RootState) => state.parkingProducts.error != null);
  const bulkImportProgress = useAppSelector((state: RootState) => state.parkingProducts.bulkImportProgress);

  // Define dispatch functions
  const startBulkInvitations = (
    seasonTicketOwnerCrmId: string,
    fileReference: string,
    request: StartBulkInvitationsRequestModel,
    onSuccess: VoidFunction
  ) => {
    dispatch(
      parkingProductsActions.startBulkInvitations(
        seasonTicketOwnerCrmId,
        fileReference,
        request,
        onSuccess
      )
    );
  };

  const validateDelegees = (
    seasonTicketOwnerCrmId: string,
    req: ValidateDelegeesRequestModel,
    onSuccess: (response: ValidateDelegeesResponseModel) => void,
    onError: (errorCode: string) => void) => {
    dispatch(parkingProductsActions.validateDelegees(
      seasonTicketOwnerCrmId,
      req,
      onSuccess,
      onError)
    );
  };

  const getBulkImportProgress = (
    seasonTicketOwnerCrmId: string,
    fileReference: string,
    pollBulkImportProgress: () => void
  ) => {
    dispatch(
      parkingProductsActions.getBulkImportProgress(
        seasonTicketOwnerCrmId,
        fileReference,
        pollBulkImportProgress
      )
    )
  };

  const getDelegeesValidationResult = (
    seasonTicketOwnerCrmId: string,
    fileReference: string,
    language: string): Promise<AxiosResponse<Blob>> => {
    return parkingProductsService.getDelegeesValidationResult(seasonTicketOwnerCrmId, fileReference,
      language);
  };

    const getDelegeesInvitationResult = (
    seasonTicketOwnerCrmId: string,
    fileReference: string,
    language: string): Promise<AxiosResponse<Blob>> => {
    return parkingProductsService.getDelegeesInvitationResult(seasonTicketOwnerCrmId, fileReference,
      language);
  };

  return (
    <MultipleDelegeesForm
      onClose={onClose}
      startBulkInvitations={startBulkInvitations}
      validateDelegeesProgress={validateDelegeesProgress}
      getBulkImportProgress={getBulkImportProgress}
      validateDelegees={validateDelegees}
      getDelegeesValidationResult={getDelegeesValidationResult}
      getDelegeesInvitationResult={getDelegeesInvitationResult}
      hasErrors={hasErrors}
      bulkImportProgress={bulkImportProgress}
      translationContextName={translationContextName}
    />
  );
};

export default ParkingRightMultipleDelegeesForm;
